import { useEffect, useRef, useState } from 'react';

const TooltipWithAction = ({
  content,
  children,
  activatorWrapper = 'span',
}: {
  content: React.ReactNode;
  children: React.ReactNode;
  activatorWrapper?: string;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const activatorRef = useRef<HTMLElement>(null);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => {
    // Thêm độ trễ nhỏ để kiểm tra xem chuột có vào tooltip không
    setTimeout(() => {
      const tooltipEl = tooltipRef.current;
      // Kiểm tra xem chuột có đang nằm trên tooltip không
      if (tooltipEl && !tooltipEl.matches(':hover')) {
        setIsVisible(false);
      }
    }, 100);
  };

  // Hàm xử lý khi rời khỏi tooltip
  const handleTooltipLeave = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    // Xử lý vị trí của tooltip khi hiển thị
    if (isVisible && tooltipRef.current && activatorRef.current) {
      const activatorRect = activatorRef.current.getBoundingClientRect();
      const tooltipEl = tooltipRef.current;

      // Đặt tooltip ở vị trí phía trên của phần tử kích hoạt
      tooltipEl.style.bottom = `${window.innerHeight - activatorRect.top + 5}px`;
      tooltipEl.style.left = `${activatorRect.left + activatorRect.width / 2}px`;
      tooltipEl.style.transform = 'translateX(-50%)';
    }
  }, [isVisible]);

  // Tạo phần tử kích hoạt với ref
  const ActivatorWrapper = activatorWrapper as any;
  const activator = (
    <ActivatorWrapper ref={activatorRef} onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
      {children}
    </ActivatorWrapper>
  );

  const tooltipStyle = {
    position: 'fixed',
    zIndex: 1000,
    backgroundColor: '#ffffff',
    color: 'white',
    padding: '0.5rem',
    borderRadius: '0.375rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    cursor: 'default', // Đảm bảo con trỏ chuột không thay đổi
  };

  return (
    <>
      {activator}
      {isVisible && (
        <div ref={tooltipRef} style={tooltipStyle as any} role="tooltip" onMouseLeave={handleTooltipLeave}>
          {content}
        </div>
      )}
    </>
  );
};

export default TooltipWithAction;
